import { createFileRoute, redirect } from '@tanstack/react-router'
import { AuthenticatedLayout } from '@/components/layout/authenticated-layout'
import { useAuthStore } from '@/stores/authStore'

export const Route = createFileRoute('/_authenticated')({
  beforeLoad: ({ location }) => {
    const token = useAuthStore.getState().auth.accessToken
    if (!token) {
      const redirectTo = location.href
      throw redirect({ to: '/sign-in', search: { redirect: redirectTo } })
    }
  },
  component: AuthenticatedLayout,
})
